// eslint-disable-next-line
import { app } from '@/config/app/app'
import VueRaw from '@/components/VueRaw'
import { Tag } from '@/components/TagsFilter'
import SimpleSlider from '@/components/SimpleSlider'
import CookiePopup from '@/components/CookiePopup'

app.component('vue-raw', VueRaw)
app.component('tag', Tag)
app.component('simple-slider', SimpleSlider)
app.component('cookie-popup', CookiePopup)
